<template>
  <el-col :span="24">
    <div class="ma-0" v-loading="loading">
      <div class="custom-table-design">
        <el-table
          :data="dataList"
          :fit="true"
          :height="$vuetify.display.width <= 700 ? 300 : 700"
          class="my-2 width-100-p data-table"
          stripe
          scrollbar-always-on: false
        >
          <el-table-column
            :label="'Customer'"
            :prop="'customer_name'"
            :width="$vuetify.display.width <= 2400 ? 250 : ''"
            sortable
          />
          <el-table-column
            :label="'Abatement (tCO2-e)'"
            :prop="'abatement_tonne'"
            :width="$vuetify.display.width <= 2400 ? 200 : ''"
            sortable
          >
            <template #default="scope">
              {{
                scope.row.abatement_tonne == null
                  ? ""
                  : Number(scope.row.abatement_tonne).toLocaleString()
              }}
            </template>
          </el-table-column>
          <el-table-column
            :label="'Usage (MWh)'"
            :prop="'usage_MWh'"
            :width="$vuetify.display.width <= 2400 ? 200 : ''"
            sortable
          >
            <template #default="scope">
              {{
                scope.row.usage_MWh == null
                  ? ""
                  : Number(scope.row.usage_MWh).toLocaleString()
              }}
            </template>
          </el-table-column>
          <el-table-column
            :label="'Abatement per MWh'"
            :prop="'abatement_per_MWh'"
            :width="$vuetify.display.width <= 2400 ? 250 : ''"
            sortable
          >
            <template #default="scope">
              {{
                scope.row.abatement_per_MWh == null
                  ? ""
                  : Number(scope.row.abatement_per_MWh).toLocaleString()
              }}
            </template>
          </el-table-column>
          <el-table-column
            :label="'Distance Travelled (km)'"
            :prop="'distance_travelled_km'"
            :width="$vuetify.display.width <= 2400 ? 250 : ''"
            sortable
          >
            <template #default="scope">
              {{
                scope.row.distance_travelled_km == null
                  ? ""
                  : Number(scope.row.distance_travelled_km).toLocaleString()
              }}
            </template>
          </el-table-column>
          <el-table-column
            :label="'Fuel Avoided (L)'"
            :prop="'fuel_avoided_l'"
            :width="$vuetify.display.width <= 2400 ? 200 : ''"
            sortable
          >
            <template #default="scope">
              {{
                scope.row.fuel_avoided_l == null
                  ? ""
                  : Number(scope.row.fuel_avoided_l).toLocaleString()
              }}
            </template>
          </el-table-column>
          <el-table-column
            :label="'Project (tCO2-e)'"
            :prop="'project_tonne'"
            :width="$vuetify.display.width <= 2400 ? 200 : ''"
            sortable
          >
            <template #default="scope">
              {{
                scope.row.project_tonne == null
                  ? ""
                  : Number(scope.row.project_tonne).toLocaleString()
              }}
            </template>
          </el-table-column>
          <el-table-column
            :label="'Emission Intensity Per EC'"
            :prop="'emission_intensity_per_EC'"
            :width="$vuetify.display.width <= 2400 ? 250 : ''"
            sortable
          >
            <template #default="scope">
              {{
                scope.row.emission_intensity_per_EC == null
                  ? ""
                  : Number(scope.row.emission_intensity_per_EC).toLocaleString()
              }}
            </template>
          </el-table-column>
          <el-table-column
            :label="'Baseline (tCO2-e)'"
            :prop="'baseline_tonne'"
            :width="$vuetify.display.width <= 2400 ? 200 : ''"
            sortable
          >
            <template #default="scope">
              {{
                scope.row.baseline_tonne == null
                  ? ""
                  : Number(scope.row.baseline_tonne).toLocaleString()
              }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
        <el-row class="row-bg" justify="space-between">
          <el-col
            :span="5"
            class="d-flex justify-content-start align-items-center"
          >
            <el-select
              v-model="perPageCount"
              placeholder="Select"
              size="small"
              style="width: 70px"
            >
              <el-option label="10" :value="'10'" />
              <el-option label="25" :value="'25'" />
              <el-option label="50" :value="'50'" />
              <el-option label="100" :value="'100'" />
              <el-option label="500" :value="'500'" />
              <el-option label="1k" :value="'1000'" />
            </el-select>
          </el-col>
          <el-col
            :span="8"
            class="d-flex align-items-center justify-content-center"
          >
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="total_items"
              v-model:page-size="page_size"
              v-model:current-page="current_page"
              @current-change="changePage"
              class="my-4"
            />
          </el-col>
          <el-col :span="5" class="d-flex justify-content-end align-items-center">
            <span class="text-white">
              {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                current_page * perPageCount > total_items
                  ? total_items.toLocaleString()
                  : (current_page * perPageCount).toLocaleString()
              }}
              of {{ total_items.toLocaleString() }}
            </span>
          </el-col>
        </el-row>
      </div>

      <div class="custom-pagination" v-if="$vuetify.display.width < 700">
        <el-row class="row-bg" justify="space-between">
          <el-col
            :span="24"
            class="d-flex align-items-center justify-content-center"
          >
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="total_items"
              v-model:page-size="page_size"
              v-model:current-page="current_page"
              @current-change="changePage"
              class="my-4"
            />
          </el-col>
          <el-col
            :span="10"
            class="d-flex justify-content-end align-items-center"
          >
            <el-select
              v-model="perPageCount"
              placeholder="Select"
              size="small"
              style="width: 70px"
            >
              <el-option label="10" :value="'10'" />
              <el-option label="25" :value="'25'" />
              <el-option label="50" :value="'50'" />
              <el-option label="100" :value="'100'" />
              <el-option label="500" :value="'500'" />
              <el-option label="1k" :value="'1000'" />
            </el-select>
          </el-col>
          <el-col :span="10" class="d-flex justify-content-start align-items-center">
            <span class="text-white">
              {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                current_page * perPageCount > total_items
                  ? total_items.toLocaleString()
                  : (current_page * perPageCount).toLocaleString()
              }}
              of {{ total_items.toLocaleString() }}
            </span>
          </el-col>
        </el-row>
      </div>

    </div>
  </el-col>
</template>

<script>
export default {
  props: {
    loadingProp: {
      type: Boolean,
      default: false,
    },
    dataProp: {
      type: Array,
      default(rawProps) {
        return rawProps;
      },
    },
    totalRowProp: {
      type: Number,
    },
  },
  components: {
    // ShowDetail,
  },
  data() {
    return {
      show: true,
      dataList: [],
      search: "",
      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,
    };
  },
  watch: {
    loadingProp: {
      handler: function (newValue) {
        this.loading = newValue;
      },
      deep: true,
    },
    dataProp: {
      handler: function (newValue) {
        this.dataList = newValue;
      },
      deep: true,
    },
    totalRowProp: {
      handler: function (newValue) {
        this.total_items = newValue;
        // console.log(this.total_items);
      },
      deep: true,
    },
    perPageCount: function (newVal) {
      this.current_page = 1;
      this.page_size = parseInt(newVal);
      this.$emit("tableAction", {
        index: this.page_size,
        data: null,
        kind: "perPageChange",
      });
    },
  },
  methods: {
    handleRowClick(row, column, event) {
      console.log(row, column, event);
    },
    changePage(page) {
      this.$emit("tableAction", {
        index: page,
        data: null,
        kind: "changePage",
      });
    },
  },
};
</script>


